import { render, staticRenderFns } from "./ActiveBacklogStacked.vue?vue&type=template&id=55c56f22&scoped=true&"
import script from "./ActiveBacklogStacked.vue?vue&type=script&lang=js&"
export * from "./ActiveBacklogStacked.vue?vue&type=script&lang=js&"
import style0 from "./ActiveBacklogStacked.vue?vue&type=style&index=0&id=55c56f22&scoped=true&lang=css&"
import style1 from "./ActiveBacklogStacked.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c56f22",
  null
  
)

export default component.exports